module.exports = __webpack_public_path__ + "static/img/zygl-bg.53abe5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/views/appCenter/img/zygl-bg.png
// module id = Wn6o
// module chunks = 96